import { BYO_OPEN_MODAL, BYO_CLOSE_MODAL, BYO_OPENING_FROM_CAMPAIGN, } from '../constants';
const initialState = {
    isModalOpen: false,
    isOpeningFromCampaign: false,
};
//eslint-disable-next-line complexity
const appReducer = (state = initialState, action = { type: '', payload: '' }) => {
    if (!action) {
        return state;
    }
    if (action.type === BYO_OPEN_MODAL) {
        return Object.assign(Object.assign({}, state), { isModalOpen: true });
    }
    if (action.type === BYO_CLOSE_MODAL) {
        return Object.assign(Object.assign({}, state), { isModalOpen: false });
    }
    if (action.type === BYO_OPENING_FROM_CAMPAIGN) {
        return Object.assign(Object.assign({}, state), { isOpeningFromCampaign: action.payload });
    }
    return state;
};
export default appReducer;
